import { javascript } from "@codemirror/lang-javascript";
import Editor from "./boxComponents/Editor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCaretLeft, faSquareCaretRight, faSquareCaretUp, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";

const JavascriptBox = ({ cStyle, icon, value, codeFunction, cWidth, onHandleClick, toggle, mousecaptuerEvent, viewPosition }) => {
    const [toggle1, toggle2, toggle3] = toggle;

    const divStyle = {
        ...cStyle[0],
        width: viewPosition ? "100%" : cWidth[2] ? `calc(${cStyle[0].width} - ${cWidth[2]}px)` : cStyle[0].width,
        height: viewPosition && cWidth[2] ? `calc(${cStyle[0].height} - ${cWidth[2]}px)` : cStyle[0].height,
        icon: {
            color: "rgb(252, 208, 0)"
        },

        boxStyle: !toggle1 && !toggle2 ? { ...cStyle[1] } : viewPosition ? { ...cStyle[1] } : { ...cStyle[2] }
    }


    return (
        <div style={divStyle} id="js">
            <div style={divStyle.boxStyle} onMouseDownCapture={mousecaptuerEvent}>
                <div style={divStyle.boxStyle.textDiv} >
                    <FontAwesomeIcon icon={icon} style={divStyle.icon} />
                    {toggle2 === true || toggle1 === true ? null : <h3 style={divStyle.boxStyle.h3}>js</h3>}
                </div>
                <FontAwesomeIcon icon={viewPosition ? toggle3 ? faSquareCaretDown : faSquareCaretUp : toggle2 ? faSquareCaretLeft : faSquareCaretRight} style={divStyle.boxStyle.button} onClick={onHandleClick} />
            </div>
            <Editor language={javascript} value={value} onChange={codeFunction} />
        </div>
    );
}

export default JavascriptBox;